import React from "react";
import { AnswerFormat, DateAnswerFormat, DateOfBirthAnswerFormat, EmailAnswerFormat, PostalCodeAnswerFormat, SurveyFormStyle, TextAnswerFormat } from "../../../../types/Survey";
import { FileQuestion, BooleanQuestion, DateQuestion, HeightQuestion, PhoneQuestion, NumericQuestion, ScaleQuestion, TextChoiceQuestion, TextQuestion, TimeOfDayQuestion, ValuePickerQuestion, WeightQuestion, SignatureQuestion } from "../../Questions";
import { ResultModel } from "../../../../types/SurveyResult";
import SurveyFormItem from "../SurveyFormItem/SurveyFormItem";
import { emailRegExString, postalRegExString } from "../../../../helpers/customFieldHelper";

export interface SurveyQuestionProps {
    answerFormat?: AnswerFormat;
    label?: string;
    placeholder?: string;
    result: ResultModel;
    onResultChange: (answer: ResultModel) => void;
    onEnterPressed: () => void;
    variant?: SurveyFormStyle;
    optional?: boolean;
    labelPosition?: "top" | "left";
    autoContinue?: () => void;
    index?: number;
    inputIdForLabel?: string;
    autoComplete?: string;
    useFieldsetFormat: boolean;
}

export default function Question(props: SurveyQuestionProps) {
    if (!props.answerFormat) {
        return <SurveyFormItem
            label={props.label}
            variant={props.variant}
            useFieldsetFormat={props.useFieldsetFormat}
            index={props.index}>
            <></>
        </SurveyFormItem>
    }

    if (props.answerFormat.type === "BooleanAnswerFormat") {
        return <BooleanQuestion {...props} />;
    } else if (props.answerFormat.type === "DateAnswerFormat") {
        return <DateQuestion {...props} />;
    } else if (props.answerFormat.type === "HeightAnswerFormat") {
        return <HeightQuestion {...props} />;
    } else if (props.answerFormat.type === "NumericAnswerFormat") {
        return <NumericQuestion {...props} />;
    } else if (props.answerFormat.type === "PhoneAnswerFormat") {
        return <PhoneQuestion {...props} autoComplete="tel"/>;
    } else if (props.answerFormat.type === "ScaleAnswerFormat" || props.answerFormat.type === "ContinuousScaleAnswerFormat") {
        return <ScaleQuestion {...props} />;
    } else if (props.answerFormat.type === "TextAnswerFormat") {
        return <TextQuestion {...props} />
    } else if (props.answerFormat.type === "TextChoiceAnswerFormat") {
        return <TextChoiceQuestion {...props} />;
    } else if (props.answerFormat.type === "TimeOfDayAnswerFormat") {
        return <TimeOfDayQuestion {...props} />;
    } else if (props.answerFormat.type === "ValuePickerAnswerFormat") {
        return <ValuePickerQuestion {...props} />;
    } else if (props.answerFormat.type === "WeightAnswerFormat") {
        return <WeightQuestion {...props} />;
    } else if (props.answerFormat.type === "FileAnswerFormat") {
        return <FileQuestion {...props} />;
    } else if (props.answerFormat.type === "EmailAnswerFormat") {
        let emailAnswerFormat = props.answerFormat as EmailAnswerFormat;
        let newProps = {
            ...props,
            autoComplete: "email",
            answerFormat: {
                type: "TextAnswerFormat",
                multipleLines: false,
                keyboardType: "Email",
                validationPattern: emailRegExString,
                invalidMessage: emailAnswerFormat.invalidMessage,
                defaultValue: emailAnswerFormat.defaultValue,
                customField: emailAnswerFormat.customField,
                demographicField: emailAnswerFormat.demographicField,
                institution: emailAnswerFormat.institution
            } as TextAnswerFormat
        }
        return <TextQuestion {...newProps} />;
    } else if (props.answerFormat.type === "DateOfBirthAnswerFormat") {
        let dobAnswerFormat = props.answerFormat as DateOfBirthAnswerFormat;
        let newProps = {
            ...props,
            autoComplete: "bday",
            answerFormat: {
                type: "DateAnswerFormat",
                style: "Date",
                textEntry: true,
                maximumDate: {
                    type: "RelativeDate",
                    fromStartOfDay: true,
                    offsetYears: -(dobAnswerFormat.minimumAge ?? 0),
                    offsetMonths: 0,
                    offsetDays: 0,
                    offsetHours: 0,
                    offsetMinutes: 0
                },
                defaultValue: dobAnswerFormat.defaultValue,
                customField: dobAnswerFormat.customField,
                demographicField: dobAnswerFormat.demographicField,
                institution: dobAnswerFormat.institution,

            } as DateAnswerFormat
        }
        return <DateQuestion {...newProps} />;
    } else if (props.answerFormat.type === "PostalCodeAnswerFormat") {
        let postalCodeAnswerFormat = props.answerFormat as PostalCodeAnswerFormat;
        let newProps = {
            ...props,
            autoComplete: "postal-code",
            answerFormat: {
                type: "TextAnswerFormat",
                multipleLines: false,
                keyboardType: "Number",
                validationPattern: postalRegExString,
                invalidMessage: postalCodeAnswerFormat.invalidMessage,
                defaultValue: postalCodeAnswerFormat.defaultValue,
                customField: postalCodeAnswerFormat.customField,
                demographicField: postalCodeAnswerFormat.demographicField,
                institution: postalCodeAnswerFormat.institution
            } as TextAnswerFormat
        }
        return <TextQuestion {...newProps} />;
    } else if (props.answerFormat.type === "SignatureAnswerFormat") {
        return <SignatureQuestion {...props} />;
    }
}